"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.values = exports.getKeys = exports.find = exports.filter = exports.map = void 0;
var map = function (arr, callback) {
    var result = [];
    arr.forEach(function (value, index) {
        result[index] = callback(value);
    });
    return result;
};
exports.map = map;
var filter = function (arr, callback) {
    var result = [];
    arr.forEach(function (value) {
        if (callback(value)) {
            result.push(value);
        }
    });
    return result;
};
exports.filter = filter;
/**
 * Iterates over elements of the array, returning the first element that the predicate returns truthy for.
 */
var find = function (arr, callback) {
    for (var i = 0; i < arr.length; i++) {
        if (callback(arr[i])) {
            return arr[i];
        }
    }
    return undefined;
};
exports.find = find;
/** @returns the non-prototype keys of the given object */
var getKeys = function (obj) {
    if (!obj)
        return undefined;
    return Object.getOwnPropertyNames(obj);
};
exports.getKeys = getKeys;
var values = function (obj) {
    var _a;
    if (!obj)
        return undefined;
    return (_a = (0, exports.getKeys)(obj)) === null || _a === void 0 ? void 0 : _a.map(function (key) { return obj[key]; });
};
exports.values = values;
//# sourceMappingURL=Arrays.js.map